module.exports = __webpack_public_path__ + "static/scale-model-of-phoenix-zoo-in-tempe-arizona-f954c707c278de4347dbbde1ed610c46.png";